import { _objectEntries } from '@naturalcycles/js-lib'
import {
  ClearbluePage,
  ManageAccountPage,
  Page,
  ParentPage,
} from '@src/app/shared/typings/enum/pages.js'

export const signupPages = [
  Page.oura,
  Page.goal,
  Page.plans,
  Page.resetPassword,
  Page.code,
  Page.consent,
  Page.credentials,
  Page.address,
  Page.payment,
  Page.orderSummary,
  Page.measuringDevice,
]

export const quizPages = [
  ParentPage.quiz,
  Page.fertilityGoal,
  Page.privacy,
  Page.name,
  Page.usps,
  Page.birthday,
  Page.fertilityGoalInfo,

  Page.birthControlMethod,
  Page.birthControlMethodInfo,
  Page.sideEffects,
  Page.sideEffectsInfo,
  Page.plannedPregnancyTiming,
  Page.hormonalBirthControlUsage,
  Page.hormonalBirthControlHowLongPlan,
  Page.hormonalBirthControlHowLongPrevent,
  Page.plannedPregnancyInfo,
  Page.learnAboutSex,
  Page.bestTimeInCycle,
  Page.knowingYourSexDrive,
  Page.sexDriveInfo,
  Page.sexFrequency,
  Page.knowPregnantDays,
  Page.menstrualCycleInfo,
  Page.testimonialInfo,
  Page.cycleLength,
  Page.periodRegularity,
  Page.periodRegularityInfo,
  Page.cycleStartDate,
  Page.medicalConditionsPlan,
  Page.medicalConditionsPrevent,
  Page.medicalConditionsInfo,
  Page.periodTrackerUsage,
  Page.whichPeriodTracker,
  Page.periodTrackerComparison,
  Page.doctorInvolvement,
  Page.partnerInvolvement,
  Page.partnerInvolvementInfo,
  Page.followPregnancyInfo,
  Page.emotionalChanges,
  Page.cycleChanges,
  Page.cycleChangesEmotions,
  Page.cycleChangesBleeding,
  Page.cycleChangesSkin,
  Page.cycleChangesSexAndLibido,
  Page.cycleChangesCervicalMucus,
  Page.cycleChangesPain,
  Page.trackingInfo,
  Page.naturalMethod,
  Page.yourMeasuringDevice,
  Page.sleepWearable,
  Page.wearYourWatchToBed,
  Page.fitResult,
  Page.deviceResult,
  Page.whichWearable,
  Page.eligibleAppleWatch,
  Page.sleepConsistency,
  Page.spendingDaysInfo,
  Page.healthGoals,
  Page.feelingStressed,
  Page.biggestStressor,
  Page.favoriteWayToUnwind,
  Page.deviceTrait,
  Page.equallyEffectiveInfo,
  Page.nightSleep,
  Page.troubleGettingBackToSleep,
  Page.purchaseNewWatch,
  Page.lastQuizPage,
]

export const billingPages = [
  ManageAccountPage.address,
  ManageAccountPage.plans,
  ManageAccountPage.payment,
  ManageAccountPage.orderSummary,
]

export const accountPages = [
  ManageAccountPage.profile,
  ManageAccountPage.settings,
  ManageAccountPage.billing,
  Page.login,
]

export const clearbluePages = _objectEntries(ClearbluePage).map(([_, v]) => v)
